import { StudentReports } from "@/pages/cursisten/$studentId/rapportages"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/rapportages/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({
    from: "/beheer/cursisten/$studentId",
  })

  return <StudentReports studentId={Number(studentId)} />
}
